const initialState = {
    enrollCount: 0,
    enrollCredit: 0,
    waitApproveCount: 0,
    waitApproveCredit: 0,
    rejectCount: 0,
    rejectCredit: 0
}

export default function (state = initialState, action) {
    // Login
    if (action.type === 'STD_DASHBOARD_ENROLL') {
        // set authen object to local store
        //console.log('STD_DASHBOARD_ENROLL')
        //console.log(state)
        //   //console.log(action)
        return action.payload;
    }

    return state;
}